
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 90 90","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#000","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M68.034 23.793h-3.58c0-11.101-8.836-20.133-19.695-20.133-10.86 0-19.695 9.032-19.695 20.133h-3.581C21.483 10.673 31.924 0 44.759 0c12.834 0 23.275 10.673 23.275 23.793z"}}),_c('path',{attrs:{"d":"M43.724 75.517c-4.848 0-8.793-3.996-8.793-8.908V52.356c0-4.912 3.945-8.908 8.793-8.908 4.849 0 8.793 3.996 8.793 8.908V66.61c0 4.912-3.944 8.908-8.793 8.908zm0-28.506c-2.91 0-5.276 2.398-5.276 5.345V66.61c0 2.947 2.367 5.345 5.276 5.345 2.91 0 5.276-2.398 5.276-5.345V52.356c0-2.947-2.367-5.345-5.276-5.345z","fill-rule":"nonzero"}}),_c('path',{attrs:{"d":"M77.123 90H12.394C9.42 90 7 87.543 7 84.523V33.408c0-3.02 2.42-5.477 5.394-5.477h64.73c2.974 0 5.393 2.457 5.393 5.477v51.115c0 3.02-2.42 5.477-5.394 5.477zM12.394 31.582c-.991 0-1.798.82-1.798 1.826v51.115c0 1.007.807 1.826 1.798 1.826h64.73c.99 0 1.797-.82 1.797-1.826V33.408c0-1.007-.806-1.826-1.798-1.826H12.394z","fill-rule":"nonzero"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/management/lock.svg